import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = ({ allowedRoles } : { allowedRoles:number[] }) => {
    const { auth } = useAuth();
    const location = useLocation();

    return (
        (auth.data?.role && allowedRoles?.includes(auth.data?.role))
            ? <Outlet />
            : auth?.data?.token
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;